import React, { useRef, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import QrScanner from 'qr-scanner';

const PREFIX = 'ReceptionBarScanner';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.root}`]: {},
}));

const ReceptionBarScanner = props => {
  const {
    className,
    meetupId,
    refresh,
    selected,
    search: outerSearch,
    setSearch: setOuterSearch,
    group: outerGroup,
    setGroup: setOuterGroup,
    ...rest
  } = props;

  const videoRef = useRef(null);
  const qrScannerRef = useRef(null);

  const handleScan = data => {
    if (data) {
      setOuterSearch(data);
    }
  };
  const handleError = err => {
    console.error(err);
  };

  useEffect(() => {
    if (videoRef.current) {
      qrScannerRef.current = new QrScanner(videoRef.current, result => handleScan(result.data), {
        highlightScanRegion: true,
        highlightCodeOutline: true,
      });
      qrScannerRef.current.start().catch(handleError);
    }

    return () => {
      if (qrScannerRef.current) {
        qrScannerRef.current.stop();
        qrScannerRef.current.destroy();
      }
    };
  }, []);

  return (
    <Root>
      <video ref={videoRef} style={{ width: '300px', height: '200px' }} autoPlay playsInline muted />
    </Root>
  );
};

ReceptionBarScanner.propTypes = {
  className: PropTypes.string,
  meetupId: PropTypes.string,
};

export default ReceptionBarScanner;
